export class UnreachableError extends Error {
  constructor(variant: never) {
    super(`Unhandled ${JSON.stringify(variant)}`)
  }
}
